import $ from 'jquery';

export const init = () => {

	$(document)
		.on('change', '.f-open__inp[type="checkbox"]', function(e) {
			var $this = $(this),
				$closest = $this.closest('.f-open'),
				$box = $closest.find('.f-open__box');

			if ( $this.is(':checked') ) {
				if ( e.isTrigger ) {
					$box.show();
				}
				else {
					$box.slideDown();
				}
			}
			else {
				if ( e.isTrigger ) {
					$box.hide();
				}
				else {
					$box.slideUp();
				}
			}
		})
		.on('click', '.f-open__link', function(e) {
			e.preventDefault();
			var $this = $(this),
				$closest = $this.closest('.f-open'),
				$box = $closest.find('.f-open__box');

			if ( $box.is(':visible') ) {
				$box.slideUp();
			}
			else {
				$box.slideDown();
			}
		}).on('change', '.f-open__inp[type="radio"]', function(e) {
			var $this = $(this),
				$closest = $this.closest('.f-open'),
				$box = $closest.find('.f-open__box');

			$('.f-open__box').slideUp();

			if ( $this.is(':checked') ) {
				if ( e.isTrigger ) {
					$box.show();
				}
				else {
					$box.slideDown();
				}
			}
		});

	// trigger
	$('.f-open__inp').trigger('change');

};
